
export default function StaffSection() {
  const staff = [
    {
      name: '岡山 太郎',
      position: '代表取締役',
      experience: '不動産業界歴25年',
      description: '岡山市の不動産市場を知り尽くした代表として、お客様に最適なご提案をいたします。',
      image: 'https://public.readdy.ai/ai/img_res/4907fc756fc3dc3b0ffe6ec46a0b2806.jpg'
    },
    {
      name: '田中 花子',
      position: '営業部長',
      experience: '不動産業界歴15年',
      description: '女性ならではの細やかな視点で、お客様のライフスタイルに合った物件をご提案します。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20businesswoman%20in%20her%2040s%20wearing%20navy%20blue%20suit%2C%20warm%20smile%2C%20confident%20appearance%2C%20modern%20office%20setting%2C%20experienced%20real%20estate%20agent%2C%20friendly%20and%20trustworthy%20expression&width=300&height=400&seq=staff2&orientation=portrait'
    },
    {
      name: '佐藤 次郎',
      position: '営業担当',
      experience: '不動産業界歴8年',
      description: '若手ながら豊富な知識と熱意で、お客様の不動産売買を全力でサポートいたします。',
      image: 'https://readdy.ai/api/search-image?query=Young%20professional%20Japanese%20businessman%20in%20his%2030s%20wearing%20light%20gray%20suit%2C%20energetic%20smile%2C%20modern%20appearance%2C%20bright%20office%20background%2C%20enthusiastic%20real%20estate%20agent%2C%20approachable%20and%20professional&width=300&height=400&seq=staff3&orientation=portrait'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            スタッフ紹介
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            経験豊富なプロフェッショナルが、お客様の不動産取引を安心してサポートいたします
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {staff.map((member, index) => (
            <div key={index} className="text-center group">
              <div className="relative mb-6 mx-auto w-64 h-80 overflow-hidden rounded-xl shadow-lg">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{member.name}</h3>
              <p className="text-blue-600 font-medium mb-2">{member.position}</p>
              <p className="text-sm text-gray-500 mb-4">{member.experience}</p>
              <p className="text-gray-600 leading-relaxed">{member.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
